module.exports = __webpack_public_path__ + "static/img/5187_phase_function_Paper_Points.fe8cdf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5187_phase_function_Paper_Points.png
// module id = eX8s
// module chunks = 0